// mantine
import { Collapse } from '@mantine/core';
// components
import { useDisclosure } from '@mantine/hooks';
import { TAttribute } from '@newo/api/gateway';
import SectionHeading from '@/components/SectionHeading';
import NoRecords from '@/components/NoRecords';
// utils

interface AttributesProps {
    attributes: TAttribute[];
    isSuccess: boolean;
}

const Attributes = ({ attributes, isSuccess }: AttributesProps) => {
    const [isOpened, { toggle }] = useDisclosure(true);
    return (
        <div>
            <SectionHeading
                isOpened={isOpened}
                title="Attributes"
                onClick={toggle}
            />
            <Collapse in={isOpened}>
                <div className="flex flex-col gap-3 p-5 pt-0">
                    {isSuccess && attributes.length === 0 ? (
                        <NoRecords>No Attributes found</NoRecords>
                    ) : undefined}
                    {attributes.map((attribute) => (
                        <div key={attribute.idn}>
                            <div className="text-xs text-gray-6">
                                {attribute.idn}
                            </div>
                            <div className="text-sm">{attribute.value}</div>
                        </div>
                    ))}
                </div>
            </Collapse>
        </div>
    );
};

export default Attributes;
